import type { Node, Edge } from '@xyflow/react';
import { buildConceptEdge } from './edge-types';

/**
 * A1 — convert an "add papers" extension result (new deduped nodes/edges from
 * the backend) into React Flow nodes/edges, laid out in a grid BELOW the current
 * graph so the additions don't overlap existing concepts. New edges may
 * reference existing node ids (they already sit on the canvas). New nodes are
 * tagged origin:'ai'.
 */
export function extendResultToReactFlow(
  result: {
    nodes: Array<{ id: string; label: string; definition: string; properties: any[] }>;
    edges: Array<{ id: string; source: string; target: string; label: string; relationshipType: string }>;
  },
  existing: Node[],
  edgeColor: string,
): { nodes: Node[]; edges: Edge[] } {
  const maxY = existing.length ? Math.max(...existing.map((n) => n.position?.y ?? 0)) : 0;
  const startY = maxY + 220;
  const cols = 4;
  const dx = 260;
  const dy = 180;

  const nodes: Node[] = result.nodes.map((n, i) => ({
    id: n.id,
    type: 'concept',
    position: { x: (i % cols) * dx, y: startY + Math.floor(i / cols) * dy },
    data: {
      label: n.label,
      definition: n.definition || '',
      properties: n.properties || [],
      origin: 'ai',
    },
  }));

  const edges: Edge[] = result.edges.map((e) =>
    buildConceptEdge({
      id: e.id || `edge-${e.source}-${e.target}`,
      source: e.source,
      target: e.target,
      edgeColor,
      data: {
        label: e.label || e.relationshipType || 'relates to',
        relationshipType: e.relationshipType || e.label || 'relates-to',
      },
    }),
  );

  return { nodes, edges };
}

// Made with Bob
